const SLOT_MS = 60 * 60 * 1000;
/** One appointment on the staff calendar: bridge status mapped, listing resolved to a car. */
export class ScheduleEntry {
    id;
    status;
    start;
    end;
    listingId;
    car;
    phone;
    notes;
    constructor(id, status, start, end, listingId, car, phone, notes) {
        this.id = id;
        this.status = status;
        this.start = start;
        this.end = end;
        this.listingId = listingId;
        this.car = car;
        this.phone = phone;
        this.notes = notes;
    }
    static fromAppointment(a, listings) {
        const listing = listings.get(a.listingId);
        const startMs = new Date(a.startsAt).getTime();
        const end = Number.isNaN(startMs) ? a.startsAt : new Date(startMs + SLOT_MS).toISOString();
        return new ScheduleEntry(a.id, a.status === "pending" ? "requested" : a.status, a.startsAt, end, a.listingId, listing
            ? { year: listing.year, make: listing.make, model: listing.model }
            : { year: 0, make: "", model: "" }, a.phone, a.notes);
    }
    carTitle() {
        return `${this.car.year} ${this.car.make} ${this.car.model}`;
    }
    /** Can still be cancelled by staff. */
    isCancellable() {
        return this.status === "requested" || this.status === "accepted";
    }
    withStatus(status) {
        return new ScheduleEntry(this.id, status, this.start, this.end, this.listingId, this.car, this.phone, this.notes);
    }
}
//# sourceMappingURL=ScheduleEntry.js.map